/**
 * Дашборд подбора (/processes/recruitment) — раньше вкладка «Подбор» в ряду фильтров списка;
 * с 16.10.2026 — кнопка «Дашборд подбора» в шапке «Процессов» (видна HR и admin). Доступ режет
 * бэк (GET /edo/recruitment/dashboard: HR — свои компании, admin — все, прочим 403 → QueryState).
 */
import { Text } from 'tamagui'

import { useApp } from '../../../src/i18n'
import { Breadcrumb } from '../../../src/features/edo/components/Breadcrumb'
import { RecruitmentDashboard } from '../../../src/features/edo/components/RecruitmentDashboard'
import { Page } from '../../../src/ui/Screen'

export default function RecruitmentDashboardScreen() {
  const { l } = useApp()
  return (
    <Page>
      <Breadcrumb items={[{ label: l('proc.title'), href: '/processes' }, { label: l('proc.dashboard') }]} />
      <Text fontSize={26} fontWeight="800" color="$color" letterSpacing={-0.4} role="heading">
        {l('proc.dashboard')}
      </Text>
      <RecruitmentDashboard />
    </Page>
  )
}
